import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EquipoService } from '../../core/equipo.service';
import { AuthService } from '../../core/auth.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-agregar-equipo',
  templateUrl: './agregar-equipo.component.html',
  styleUrls: ['./agregar-equipo.component.css']
})
export class AgregarEquipoComponent implements OnInit {
  chequeado = false;
  contador;
  usuarios$: Observable<any[]>;

  constructor(public activeModal: NgbActiveModal, public es: EquipoService, public authService: AuthService) { }

  ngOnInit() {
    this.usuarios$ = this.es.getUsers();
    this.contador = this.es.getCfg();
  }

  cerrarModal() {
    this.activeModal.close();
  }


  buscar($event) {
    this.es.filtroNombre($event.target.value);
  }

  toggleEquipo(userId: any, variable, cont:number){
    if(variable){
      this.es.actualizar(userId,
        {
          equipo: false,
          posicion: null
        }
      );
      this.es.actualizarCont({
        contEquipo: cont - 1
      })
    }else{
      this.es.actualizar(userId,
        {
          equipo: true,
          posicion: cont
        }
      );
      this.es.actualizarCont({
        contEquipo: cont + 1
      })
    }
  }

  toggleAdmin(userId: any, variable) {
    if(variable){
      this.es.actualizar(userId,
        {
          admin: false,
        }
      );
    }else{
      this.es.actualizar(userId,
        {
          admin: true,
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modulos/agregar-equipo/agregar-equipo.component.ts